import * as React from "react";
import ReactDOM from "react-dom/client";
import { flushSync } from "react-dom";
import {App} from "./app/App";
import "./styles.scss";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig, tokenRequest } from "./auth/config";
import { registerApplication, start } from "single-spa";
const appMsalInstance = new PublicClientApplication(msalConfig);

declare const System: { import: (name: string) => Promise<any> };

const configUrl = `${process.env.PUBLIC_URL}/microfrontends.json`;

async function bootstrap() {
  await appMsalInstance.initialize()
  const res = await fetch(configUrl);
  const { apps } = await res.json();

  // ✅ Dynamically inject child app imports
  const importMap = { imports: {} as Record<string, string> };
  apps.forEach((app: { name: string; url: string }) => {
    importMap.imports[app.name] = app.url;
  });

  const script = document.createElement("script");
  script.type = "systemjs-importmap";
  script.textContent = JSON.stringify(importMap);
  document.head.appendChild(script);

    // Get token dynamically — fetch fresh accounts each time (not stale closure)
  const getToken = async (): Promise<string> => {
    const accounts = appMsalInstance.getAllAccounts()
    if (accounts.length === 0) return ''
    try {
      const response = await appMsalInstance.acquireTokenSilent({
        ...tokenRequest,
        account: accounts[0],
      })
      return response.accessToken
    } catch {
      return ''
    }
  }

  // ✅ Dynamically register each app
  apps.forEach((app: { name: string; activeWhen: string }) => {
    registerApplication({
      name: app.name,
      app: () => System.import(app.name),
      activeWhen: (location) => location.pathname.startsWith(app.activeWhen),
       customProps: {
        msalInstance: appMsalInstance,
        getToken,           
      // tells child app to mount inside #root, not document.body
      domElementGetter: () => {
        const id = `single-spa-application:${app.name}`
        let el = document.getElementById(id)
        if (!el) {
          el = document.createElement('div')
          el.id = id
          // mount inside #root, not body
          document.getElementById('root')!.appendChild(el)
        }
        return el
      },
    },
    });
  });


  const root = ReactDOM.createRoot(document.getElementById("root")!);
  flushSync(() => {
    root.render(
      <React.StrictMode>
        <MsalProvider instance={appMsalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>,
    );
  });

  start({ urlRerouteOnly: true });
}
bootstrap();
